import { GET_ALL_USER_TYPES } from '../../types'

const INITIAL_STATE = {
  getAllUserType: [],
}

const userTypeReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_USER_TYPES:
      return {
        ...state,
        getAllUserType: payload.data,
        loader: false,
      }

    default:
      return state
  }
}

export default userTypeReducer
